import { Helmet } from "react-helmet"

function Svijet() {
    return (
        <div className="flex-container full-width flex-grow-1">
             <Helmet>
                <title>Korisni linkovi - Svijet</title>
                <meta
                    name="description"
                    content="Korisni linkovi vezani za svijet"
                    data-react-helmet="true" 
                />
            </Helmet>
            <p className="full-width padding-2p static-page-container">
                <a target="_blank"
                    rel='noreferrer'
                    href="https://www.geschichte.hu-berlin.de/en/bereiche-und-lehrstuehle-en/suedosteuropaeische-geschichte-en"
                    className="full-width"    
                >
                    Chair for Southeast European History
                </a>
            </p>
        </div>
    )
}

export default Svijet